import { create } from "zustand"

export type SellerNavItem = "dashboard" | "profile" | "rfqs" | "quotations" | "orders" | "products" | "complaints" | "notifications"

interface SellerUIState {
  activeNav: SellerNavItem
  sidebarCollapsed: boolean
  setActiveNav: (nav: SellerNavItem) => void
  toggleSidebar: () => void
  setSidebarCollapsed: (collapsed: boolean) => void
}

export const useSellerUIStore = create<SellerUIState>((set) => ({
  activeNav: "dashboard",
  sidebarCollapsed: typeof window !== "undefined" ? window.innerWidth < 768 : false,
  setActiveNav: (activeNav) => set({ activeNav }),
  toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
  setSidebarCollapsed: (sidebarCollapsed) => set({ sidebarCollapsed }),
}))
